import { ComponentsPropsList } from '@material-ui/core';

export const defaultThemeProps = (
  props: {
    [Name in keyof ComponentsPropsList]?: Partial<ComponentsPropsList[Name]>;
  }
) => {
  props = {
    MuiPopover: {
      disableScrollLock: false,
    },
  };
  return props;
};
